import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { SecurityElementNames } from 'src/app/shared/auth/constants/security-element-names.service';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { CreditCardGatewayService } from '../shared/credit-card-gateway/credit-card-gateway.service';
import { TransactionStateEnum } from '../shared/transaction/transaction-state.enum';
import { TransactionSummaryItemDto } from '../shared/transaction/transaction-summary-item.dto';
import { TransactionSummarySearchDto } from '../shared/transaction/transaction-summary-search.dto';
import { TransactionSummaryService } from '../shared/transaction/transaction-summary-service';
import { SettingService } from 'src/app/config/shared/setting/setting.service';

@Component({
  selector: 'wl-credit-card-activity',
  templateUrl: './credit-card-activity.component.html',
  styleUrls: ['./credit-card-activity.component.less'],
    standalone: false
})
export class CreditCardActivityComponent implements OnInit {
  searchParams: TransactionSummarySearchDto;
  searchResult: Array<TransactionSummaryItemDto>;
  creditCardGateways: Array<SelectItem>;
  busy = false;
  pageSize = 20;
  first = 0;
  transactionStateEnum = TransactionStateEnum;
  exporting: boolean;
  private _arbEnabled = false;

  get arbEnabled() {
    return this._arbEnabled;
  }
  constructor(
    public securityElementNames: SecurityElementNames,
    private _transactionSummaryService: TransactionSummaryService,
    private _ccGateWayService: CreditCardGatewayService,
    private _navigationService: NavigationService,
    private _settingService: SettingService
  ) {
    let startDate = new Date();
    new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDay());
    this.searchParams = { StartDate: startDate } as TransactionSummarySearchDto;
    this.searchResult = [];
    this.creditCardGateways = [];
  }

  ngOnInit(): void {
    Promise.all([
      this._settingService.arbEnabled().then((data) => {
        this._arbEnabled = data;
      }),
    ]);
    this._ccGateWayService.getAllCreditCardGateways().then((data) => {
      this.creditCardGateways = data.map((x) => {
        return { label: x.Name, value: x.CCGatewayID };
      });
    });
  }

  search() {
    this.busy = true;
    this._transactionSummaryService
      .searchTransactionSummary(this.searchParams)
      .then((data) => {
        this.searchResult = data;
        this.first = 0;
      })
      .finally(() => {
        this.busy = false;
      });
  }

  clear() {
    this.searchResult = [];
  }

  exportClick() {
    this.exporting = true;
    this._transactionSummaryService
      .export(this.searchParams)
      .then((csvUrl) => {
        this._navigationService.popupSafeNavigate(csvUrl);
      })
      .finally(() => {
        this.exporting = false;
      });
  }
}
